<script>
import { GlTooltip, GlCard } from '@gitlab/ui';
import * as timeago from 'timeago.js';
import { dateTimeMixin } from '~/utils/datetime';
import GlMarkdown from './markdown.vue';

export default {
  name: 'GlComment',
  components: {
    GlMarkdown,
    GlTooltip,
    GlCard,
  },
  mixins: [dateTimeMixin],
  props: {
    note: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
  },
  computed: {
    postTime() {
      return `Posted ${timeago.format(this.createdAt)}`;
    },
  },
};
</script>

<template>
  <gl-card class="gl-mb-5">
    <gl-markdown :text="note" />
    <div ref="postedTime" class="gl-display-inline-block gl-mt-5 gl-font-sm gl-text-gray-700">
      {{ postTime }}
    </div>
    <gl-tooltip :target="() => $refs.postedTime">
      <div class="gl-display-block gl-align-items-center gl-font-sm">
        <div class="gl-mb-2">{{ formatDateTime(createdAt) }}</div>
        <div>{{ formatDateTimeZone(createdAt) }}</div>
      </div>
    </gl-tooltip>
  </gl-card>
</template>
